var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bulk-edit-games',{attrs:{"is-loading":_vm.isLoading,"project-list":_vm.projectList,"update-difference":_vm.updateDiff},on:{"bulk-update":_vm.onUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }